import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { Suspense, useEffect } from "react";
import { getFavicon } from "./storage/storage";

import GymBranchList from "./pages/Branch/BranchList/List";
import CreateGymBranch from "./pages/Branch/BranchCreate/CreateBranch";
import ViewGymBranch from "./pages/Branch/BranchView/BranchView";
import BranchEdit from "./pages/Branch/BranchEdit/BranchEdit";


import Mealdetail from "./pages/Meals/MealsList/MealDetail/Mealdetail";

import AdminPlan from "./pages/AdminPlan/AdminPlanList/AdminPlan";
import AdminplanCreate from "./pages/AdminPlan/AdminPlanCreate/AdminplanCreate";
import AdminPlanEdit from './pages/AdminPlan/AddminPlanEdit/AdminPlanEdit'
import AdminPlanView from "./pages/AdminPlan/AdminPlanView/AdminPlanView";
import AssignedMealList from "./pages/Meals/AssignedMealList/AssignedMealList";
import Editmeal from "./pages/Meals/EditAssignedMeal/Editmeal";
import ViewMeal from "./pages/Meals/ViewAssignedMeal/ViewMeal";
import Test from "./utils/Test";
import { ColorProvider } from "./utils/ColorProvider";

import Fooditem from "./pages/Meals/FoodItemList/Fooditem";
import AddFoodItem from "./pages/Meals/AddFoodItem/AddFoodItem";
import EditFoodItem from "./pages/Meals/EditFoodItem/EditFoodItem";
import MemberMealsList from "./pages/memberpages/Meals/MemberMealsList";
import MemberAnswers from "./pages/memberpages/Meals/MemberAnswers";
import MemberVideo from "./pages/memberpages/Videos/MemberVideo";
import AppointmentList from "./pages/Appointment/AppointmentList/AppointmentList";
import VendorProductsList from "./pages/Store/Vendor/catalog/products/Product-list/VendorProductsList";
import ProductCreate from "./pages/Store/Vendor/catalog/products/Product-create/ProductCreate";
import VendorProductUpdate from "./pages/Store/Vendor/catalog/products/Product-update/VendorProductUpdate";
import VendorProductView from "./pages/Store/Vendor/catalog/products/Product-view/VendorProductView";
import WarehouseList from "./pages/Store/Vendor/warehouse/warehouselist/WarehouseList";
import WarehouseCreate from "./pages/Store/Vendor/warehouse/warehousecreate/WarehouseCreate";
import AdminProductsList from "./pages/Store/Admin/catalog/products/Product-list/AdminProductsList";
import AdminRequestProductsList from "./pages/Store/Admin/catalog/products-request/Product-list/AdminProductsList";
import AdminProductView from "./pages/Store/Admin/catalog/products-request/Product-view/AdminProductView";
import FytBotAttendeceList from "./pages/FytbotAttendanceLog/FytBotAttendeceList";
import AppointmentView from "./pages/Appointment/AppointmentView/AppointmentView";


const Addworkout = React.lazy(() => import("./pages/Workout/AddWorkout/Addexercise"));
const Login = React.lazy(() => import("./pages/Login/Login"));
const Dashboard = React.lazy(() => import("./pages/Dashboard/Dashboard"));
const Layout = React.lazy(() => import("./components/layout/Layout"));
const CreateUser = React.lazy(() => import("./pages/User/UserCreate/Create"));

const GymStaffView = React.lazy(() => import("./pages/GymStaff/GymStaffView/GymStaffView"))
const UserList = React.lazy(() => import("./pages/User/UserList/List"));
// const AttendanceList = React.lazy(() => import("./pages/Attendance/AttendanceList/List"));
const DeviceList = React.lazy(() => import("./pages/Device/DeviceList/List"));
const CameraList = React.lazy(() => import("./pages/Camera/CameraConfiguration/List"));
const FingerprintList = React.lazy(() => import("./pages/Fingerprint/FingerprintConfiguration/List"));
const SystemList = React.lazy(() => import("./pages/System/SystemConfiguration/List"));
const PrivateRoute = React.lazy(() => import("./components/common/Route/PrivateRoute"));
const View = React.lazy(() => import("./pages/RolesPermission/Viewpage/ViewRP"));
const Create = React.lazy(() => import("./pages/Device/DeviceCreate/Create"));
const CreateFingerprint = React.lazy(() => import("./pages/Fingerprint/CreateFingerprint/CreateFingerprint"));
const CreateSetting = React.lazy(() => import("./pages/Camera/Create/CreateSetting"));
const SystemSetting = React.lazy(() => import("./pages/System/Create/SystemSetting"));
const CreateLogs = React.lazy(() => import("./pages/Attendance/AttendanceCreate/Createlog"));
const GymList = React.lazy(() => import("./pages/Gym/Gymlist/list"));
const GymCreate = React.lazy(() => import("./pages/Gym/GymCreate/CreateGym"));
const Editrp = React.lazy(() => import("./pages/RolesPermission/EditList/EditList"));
const GymEdit = React.lazy(() => import("./pages/Gym/GymEdit/GymEdit"));
const GymView = React.lazy(() => import("./pages/Gym/GymView/GymView"));
const RequestedList = React.lazy(() => import("./pages/Requested-Gym/RequestedList/RequestedList"));
const UsersList = React.lazy(() => import("./pages/MobileAppUsers/MobileUsersList/MobileUserList"));

const RequestedView = React.lazy(() => import("./pages/Requested-Gym/ViewRequest/View"));

const GymStaffList = React.lazy(() => import("./pages/GymStaff/GymStaffList/list"));
const GymStaffCreate = React.lazy(() => import("./pages/GymStaff/GymStaffCreate/CreateGymStaff"));
const CreateRP = React.lazy(() => import("./pages/RolesPermission/CreateRP/CreateRP"));
const RPList = React.lazy(() => import("./pages/RolesPermission/RPList/RPlist"));
const Video = React.lazy(() => import("./pages/videos/VideoList/video"));
const AddVideo = React.lazy(() => import("./pages/videos/AddVideo/addvideo"))
const PlanList = React.lazy(() => import("./pages/Plan/PlanList/List"))
const PlanView = React.lazy(() => import("./pages/Plan/PlanView/Planview"))
const PlanCreate = React.lazy(() => import("./pages/Plan/PlanCreate/PlanCreate"))
const PlanEdit = React.lazy(() => import("./pages/Plan/PlanEdit/PlanEdit"))
const MemberList = React.lazy(() => import("./pages/Member/MemberList/MemberList"))
const MemberView = React.lazy(() => import("./pages/Member/MemberView/Memberview"))
const MemberEdit = React.lazy(() => import("./pages/Member/MemberEdit/MemberEdit"))
const MemberCreate = React.lazy(() => import("./pages/Member/MemberCreate/MemberCreate"))
const AttendanceList = React.lazy(() => import("./pages/AttendenceLog/AttendenceList/AttendeceList"))
const AttendanceCreate = React.lazy(() => import("./pages/AttendenceLog/CreateAttendanceLog/CreateLog"))
const Editvideo = React.lazy(() => import("./pages/videos/EditVideo/Editvideo"))
const MealsList = React.lazy(() => import("./pages/Meals/MealsList/MealList"))
const AddQuestion = React.lazy(() => import("./pages/Meals/AddQuestion/addQuestion"))
const QuestionList = React.lazy(() => import("./pages/Meals/QuestionList/QuestionList"))
const AssginMeal = React.lazy(() => import("./pages/Meals/AssignMeal/assignmeal"))
const Workout = React.lazy(() => import("./pages/Workout/list"))
const Editworkout = React.lazy(() => import("./pages/Workout/EditWorkout/editworkout"))
const EditGymStaff = React.lazy(() => import("./pages/GymStaff/EditGymStaff/Editgymstaff"))

// Loading spinner component

const LoadingSpinner = () => (
  <div className="loading-spinner">
    <div className="spinner"></div>
  </div>
);

function App() {
  const routes = [
    { path: "/", element: <Login />, isProtected: false }, // login
    { path: "*", element: <div>404 - Page Not Found</div>, isProtected: false }, // 404 page
    { path: "/dashboard", element: <Dashboard />, isProtected: true }, // dashboard
    { path: "/gym-list", element: <GymList />, isProtected: true }, // gym list
    { path: "/create-gym", element: <GymCreate />, isProtected: true }, // create gym
    { path: "/edit-gym", element: <GymEdit />, isProtected: true }, // edit gym
    { path: "/view-gym", element: <GymView />, isProtected: true }, // view gym
    { path: "/requested-list", element: <RequestedList />, isProtected: true },
    { path: "/mobile-user-list", element: <UsersList />, isProtected: true },

    { path: "/requested-view", element: <RequestedView />, isProtected: true }, // view gym
    { path: "/gym-staff-list", element: <GymStaffList />, isProtected: true }, // gym staff list
    { path: "/create-gym-staff", element: <GymStaffCreate />, isProtected: true }, // create gym staff
    { path: "/gym-branch-list", element: <GymBranchList />, isProtected: true }, // gym Branch list
    { path: "/create-branch", element: <CreateGymBranch />, isProtected: true }, // create Branch
    { path: "/view-branch", element: <ViewGymBranch />, isProtected: true }, // view Branch
    { path: "/edit-branch", element: <BranchEdit />, isProtected: true }, // edit Branch
    { path: "/edit-rp", element: <Editrp />, isProtected: true },
    { path: "/Videos", element: <Video />, isProtected: true },
    { path: "/add-video", element: <AddVideo />, isProtected: true },
    { path: "/edit-video", element: <Editvideo />, isProtected: true },
    { path: "/view-rp", element: <View />, isProtected: true },
    { path: "/create-user", element: <CreateUser />, isProtected: true },
    { path: "/create-device", element: <Create />, isProtected: true },
    { path: "/user-list", element: <UserList />, isProtected: true },
    { path: "/attendance-list", element: <AttendanceList />, isProtected: true },
    { path: "/create-log", element: <CreateLogs />, isProtected: true },
    { path: "/device-list", element: <DeviceList />, isProtected: true },
    { path: "/camera-configuration", element: <CameraList />, isProtected: true },
    { path: "/fingerprint-configuration", element: <FingerprintList />, isProtected: true },
    { path: "/system-configuration", element: <SystemList />, isProtected: true },
    { path: "/create-fingerprint", element: <CreateFingerprint />, isProtected: true },
    { path: "/create-setting", element: <CreateSetting />, isProtected: true },
    { path: "/system-setting", element: <SystemSetting />, isProtected: true },
    { path: "/roles-permission-list", element: <RPList />, isProtected: true },
    { path: "/create-roles-permission", element: <CreateRP />, isProtected: true },
    { path: "/plan-list", element: <PlanList />, isProtected: true },
    { path: "/create-plan", element: <PlanCreate />, isProtected: true },
    { path: "/view-plan", element: <PlanView />, isProtected: true },
    { path: "/edit-plan", element: <PlanEdit />, isProtected: true },
    { path: "/member-list", element: <MemberList />, isProtected: true },
    { path: "/member-view", element: <MemberView />, isProtected: true },
    { path: "edit-member", element: <MemberEdit />, isProtected: true },
    { path: "/member-create", element: <MemberCreate />, isProtected: true },
    { path: "/attendance-list", element: <AttendanceList />, isProtected: true },
    { path: "/create-attendance", element: <AttendanceCreate />, isProtected: true },



    { path: "/meals-list", element: <MealsList />, isProtected: true },
    { path: "/assign-meal", element: <AssginMeal />, isProtected: true },
    { path: "/add-question", element: <AddQuestion />, isProtected: true },
    { path: "/question-list", element: <QuestionList />, isProtected: true },
    { path: "/Workout", element: <Workout />, isProtected: true },
    { path: "/add-workout", element: <Addworkout />, isProtected: true },
    { path: "/edit-workout", element: <Editworkout />, isProtected: true },
    { path: "/adminplan-list", element: <AdminPlan />, isProtected: true },
    { path: "/create-adminplan", element: <AdminplanCreate />, isProtected: true },
    { path: "/edit-adminplan", element: <AdminPlanEdit />, isProtected: true },
    { path: "/view-adminplan", element: <AdminPlanView />, isProtected: true },
    { path: "/meal-detail/:id", element: <Mealdetail />, isProtected: true },
    { path: "/gym-staff-view", element: <GymStaffView />, isProtected: true },
    { path: "/edit-gym-staff", element: <EditGymStaff />, isProtected: true },
    { path: "/asigned-meal-list", element: <AssignedMealList />, isProtected: true },
    { path: "/asigned-meal-edit", element: <Editmeal />, isProtected: true },
    { path: "/asigned-meal-view", element: <ViewMeal />, isProtected: true },
    { path: "/themes", element: <Test />, isProtected: true },
    { path: "/mealitem-list", element: <Fooditem />, isProtected: true },
    { path: "/create-mealitem", element: <AddFoodItem />, isProtected: true },
    { path: "/edit-mealitem", element: <EditFoodItem />, isProtected: true },
    { path: "/member-meals", element: <MemberMealsList />, isProtected: true },
    { path: "/member-answers", element: <MemberAnswers />, isProtected: true },
    { path: "/member-videos", element: <MemberVideo />, isProtected: true },



    { path: "/appointment-list", element: <AppointmentList />, isProtected: true },
    { path: "/product-list", element: <VendorProductsList />, isProtected: true },
    { path: "/create-product", element: <ProductCreate />, isProtected: true },
    { path: "/edit-product/:id/", element: <VendorProductUpdate />, isProtected: true },
    { path: "/product-view/:id/", element: <VendorProductView />, isProtected: true },

    { path: "/warehouse-list", element: <WarehouseList />, isProtected: true },
    { path: "/warehouse-create", element: <WarehouseCreate />, isProtected: true },


    { path: "/admin-product-list", element: <AdminProductsList />, isProtected: true },
    { path: "/admin-product-request-list", element: <AdminRequestProductsList />, isProtected: true },
    { path: "/adminproduct-view/:id/", element: <AdminProductView />, isProtected: true },
    { path: "/fytbotatendecelog", element: <FytBotAttendeceList />, isProtected: true },

    { path: "/appointmentview/:id/", element: <AppointmentView />, isProtected: true },





  ];

  const faviconURL = getFavicon();
  function setFavicon(faviconURL) {
    if (faviconURL) {
      let link =
        document.querySelector("link[rel='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "icon";
      link.href = faviconURL;

      if (!document.querySelector("link[rel='icon']")) {
        document.head.appendChild(link);
      }
    }
  }

  useEffect(() => {
    setFavicon(faviconURL);
  }, [faviconURL]);

  return (
    <div className="app">
      <ColorProvider>
        <Router>
          <Suspense fallback={<LoadingSpinner />}>
            <Layout>
              <Routes>
                {routes.map(({ path, element, isProtected }) =>
                  isProtected ? (
                    <Route
                      key={path}
                      path={path}
                      element={<PrivateRoute>{element}</PrivateRoute>}
                    />
                  ) : (
                    <Route key={path} path={path} element={element} />
                  )
                )}
              </Routes>
            </Layout>
          </Suspense>
        </Router>
      </ColorProvider>

    </div>
  );
}

export default App;
